import React from 'react';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import { BhiDialog } from 'src/UIKit';

/** Which activation requirement the company failed. `null` keeps the dialog shut. */
export type GateReason = 'onboarding' | 'subscription';

export interface ActivationGateDialogProps {
  reason: GateReason | null;
  onClose: () => void;
  /** Both variants offer this — a blocked campaign can always be parked as a draft. */
  onSaveAsDraft: () => void;
  /** Onboarding variant only: save the draft, then head to account setup. Omit to hide it. */
  onCompleteSetup?: () => void;
}

export const ActivationGateDialog: React.FC<ActivationGateDialogProps> = ({
  reason,
  onClose,
  onSaveAsDraft,
  onCompleteSetup,
}) => (
  <BhiDialog
    open={reason !== null}
    onClose={onClose}
    title={reason === 'onboarding' ? 'Complete Account Setup to Activate' : 'Subscription Required'}
  >
    <DialogContent>
      {reason === 'onboarding'
        ? 'You must finish account setup and have an active subscription to activate your campaign. Complete account setup to get started.'
        : 'An active subscription is required to create campaigns. You can save this campaign as a draft and activate it later.'}
    </DialogContent>
    <DialogActions>
      {reason === 'subscription' && (
        <Box sx={{ padding: '10px' }}>
          <Button onClick={onSaveAsDraft} color="primary" variant="contained">
            Save as Draft
          </Button>
        </Box>
      )}
      {reason === 'onboarding' && (
        <Box sx={{ padding: '10px' }}>
          <Button
            sx={{ marginRight: '10px' }}
            onClick={onSaveAsDraft}
            color="primary"
            variant="outlined"
          >
            Save as Draft
          </Button>
          {onCompleteSetup && (
            <Button onClick={onCompleteSetup} color="primary" variant="contained">
              Complete Account Setup
            </Button>
          )}
        </Box>
      )}
    </DialogActions>
  </BhiDialog>
);
